export const addSubtitlesToYoutubeVideos = (videoSrc) => {
	if (videoSrc.indexOf('youtube.com') === -1 || videoSrc.indexOf('cc_load_policy') >= 0) {
		return videoSrc;
	}

	const showSubtitles = 'cc_load_policy=1&cc_lang_pref=en';
	const splitCharacter = videoSrc.indexOf('?') >= 0 ? '&' : '?';

	return videoSrc + splitCharacter + showSubtitles;
};